import React, { useState } from 'react'
import styled from 'styled-components'
import { Segment } from '../Segment'
import { Separator } from '../Separator'
import { breakpoint } from '@sketch/global-styles'

const TabsContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-bottom: 64px;
`

const Tabs = styled.div`
  display: flex;
  padding: 16px;
`

const Container = styled.div`
  overflow-y: auto;
  height: 100%;
  flex-shrink: 1;
  position: relative;
`

const FullWidthSeparator = styled(Separator)`
  /* Extend separator to full modal width by negating Modal.Body padding */
  margin-left: -16px;
  margin-right: -16px;

  ${breakpoint('sm')`
    margin-left: -32px;
    margin-right: -32px;
  `}
`

export interface ModalTabsProps {
  steps: {
    title: string
    content: React.ReactNode
  }[]
}

export const ModalTabs = ({ steps }: ModalTabsProps) => {
  const [currentStep, setCurrentStep] = useState(0)

  return (
    <TabsContainer>
      <Tabs>
        {steps.map(({ title }, index) => (
          <div key={title + index} onClick={() => setCurrentStep(index)}>
            <Segment type="text" label={title} active={currentStep === index} />
          </div>
        ))}
      </Tabs>
      <FullWidthSeparator />
      <Container>{steps[currentStep].content}</Container>
    </TabsContainer>
  )
}
